import { useSafeLayoutEffect as p, useEvent as g, useLiveRef as E } from "./ABQUS43J.js";
import { __spreadProps as R, __spreadValues as S } from "./3YLGPPWQ.js";
import { identity as h, hasOwnProperty as m } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/PBFD2E7P.js";
import { init as x, subscribe as v, sync as V, batch as _ } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/BCALMBPZ.js";
import * as l from "react";
import C from "../../../../../../../../_virtual/index.js";
var { useSyncExternalStore: b } = C, d = () => () => {
};
function P(e, r = h) {
  const t = l.useCallback(
    (n) => e ? v(e, null, n) : d(),
    [e]
  ), i = () => {
    const n = typeof r == "string" ? r : null, u = typeof r == "function" ? r : null, s = e == null ? void 0 : e.getState();
    if (u) return u(s);
    if (s && n && m(s, n))
      return s[n];
  };
  return b(t, i, i);
}
function q(e, r) {
  const t = l.useRef(
    {}
  ), i = l.useCallback(
    (u) => e ? v(e, null, u) : d(),
    [e]
  ), n = () => {
    const u = e == null ? void 0 : e.getState();
    let s = !1;
    const o = t.current;
    for (const f in r) {
      const a = r[f];
      if (typeof a == "function") {
        const c = a(u);
        c !== o[f] && (o[f] = c, s = !0);
      }
      if (typeof a == "string") {
        if (!u || !m(u, a)) continue;
        const c = u[a];
        c !== o[f] && (o[f] = c, s = !0);
      }
    }
    return s && (t.current = S({}, o)), t.current;
  };
  return b(i, n, n);
}
function A(e, r, t, i) {
  const n = m(r, t) ? r[t] : void 0, u = i ? r[i] : void 0, s = E({ value: n, setValue: u });
  p(() => V(e, [t], (o, f) => {
    const { value: a, setValue: c } = s.current;
    c && o[t] !== f[t] && o[t] !== a && c(o[t]);
  }), [e, t]), p(() => {
    if (n !== void 0)
      return e.setState(t, n), _(e, [t], () => {
        n !== void 0 && e.setState(t, n);
      });
  });
}
function B(e, r) {
  const [t, i] = l.useState(() => e(r));
  p(() => x(t), [t]);
  const n = l.useCallback(
    (o) => P(t, o),
    [t]
  ), u = l.useMemo(
    () => R(S({}, t), { useState: n }),
    [t, n]
  ), s = g(() => {
    i((o) => e(S(S({}, r), o.getState())));
  });
  return [u, s];
}
export {
  B as useStore,
  A as useStoreProps,
  P as useStoreState,
  q as useStoreStateObject
};
//# sourceMappingURL=YV4JVR4I.js.map
